<template>
  <transition name="fade">
    <ul
      class="generic-error-section"
      v-if="Object.keys(parsedError).length > 0"
    >
      <li class="icon"><img src="@/assets/images/error-icon.svg" alt="" /></li>
      <li v-for="(message, idx) in parsedError" :key="idx">
        {{ message }}
      </li>
    </ul>
  </transition>
</template>

<script>
import {
  compose,
  equals,
  filter,
  hasPath,
  is,
  isEmpty,
  isNil,
  join,
  map,
  of,
  pathOr,
  pathSatisfies,
  prop,
  reject,
  toPairs,
  has
} from "ramda";

export default {
  props: ["errors"],
  computed: {
    parsedError() {
      if (isEmpty(this.errors) || isNil(this.errors)) {
        return [];
      }
      if (is(Error, this.errors)) {
        if (
          hasPath(["response", "data"], this.errors) &&
          !pathSatisfies(is(String), ["response", "data"], this.errors)
        ) {
          return compose(
            map(([key, value]) => {
              if (key === "key") {
                return this.$t(`${value}`);
              }
              return value;
            }),
            // map(compose(join(" "), filter(isNaN), reject(equals("detail")))),
            toPairs,
            pathOr([], ["response", "data"])
          )(this.errors);
        }

        return compose(of, prop("message"))(this.errors);
      }

      if (is(Array, this.errors)) {
        return this.errors.map(error => {
          if (is(Object, error) && has("key", error)) {
            return this.$t(`${error.key}`);
          }
          return error;
        });
      }

      if (is(String, this.errors)) {
        return of(this.errors);
      }

      if (is(Object, this.errors)) {
        if (has("key", this.errors)) {
          return of(this.$t(`${this.errors.key}`));
        }
        return compose(map(join(" ")),
        map(([key, value]) => {
            if (key === "key") {
              return this.$t(`${value}`);
            }
            return value;
          }),
        toPairs)(this.errors);
      }

      return [this.$t("common.generic_error_message")];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.generic-error-section {
  padding: 16px;
  list-style: none;
  color: #000000;
  background: rgba(235, 87, 87, 0.2);
  border: 2px solid #eb5757;
  box-sizing: border-box;
  border-radius: 8px;

  .icon {
    position: absolute;
    img {
      filter: invert(46%) sepia(53%) saturate(1094%) hue-rotate(320deg)
        brightness(94%) contrast(95%);
    }
  }
  & > li:not(.icon) {
    margin-left: 30px;
  }
}
</style>
